import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';

export const assertDefined = <T,>(
	value: T,
	id: string,
	packageName: string,
	teamName: string,
	skipSentry = false,
	validator?: (value: T) => boolean,
) => {
	try {
		if (validator ? !validator(value) : value === undefined || value === null) {
			fireErrorAnalytics({
				error: new Error('value is not defined'),
				meta: {
					id,
					packageName,
					teamName,
				},
				skipSentry,
			});
		}
	} catch (error) {
		// just in case
		// fireErrorAnalytics will throw if __SERVER__ is true
	}
};
